import { render, staticRenderFns } from "./VolunteerProfileAvailabilitiesDialog.vue?vue&type=template&id=595b20a5&scoped=true"
import script from "./VolunteerProfileAvailabilitiesDialog.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileAvailabilitiesDialog.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileAvailabilitiesDialog.vue?vue&type=style&index=0&id=595b20a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595b20a5",
  null
  
)

export default component.exports